import { render, staticRenderFns } from "./linkList.vue?vue&type=template&id=0b76e354&scoped=true&"
import script from "./linkList.vue?vue&type=script&lang=js&"
export * from "./linkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76e354",
  null
  
)

export default component.exports